// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/location-schema',
  type: 'object',
  required: ['latitude', 'longitude'],
  properties: {
    latitude: {
      type: 'number',
    },
    longitude: {
      type: 'number',
    },
  },
} as IJSONSchema;

export default schema;
